function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFFEFA",
  d: "M21,40.5C10.248,40.5,1.5,31.752,1.5,21C1.5,10.248,10.248,1.5,21,1.5c10.752,0,19.5,8.748,19.5,19.5 C40.5,31.752,31.752,40.5,21,40.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F6921E",
  d: "M21,3c9.925,0,18,8.075,18,18c0,9.925-8.075,18-18,18c-9.925,0-18-8.075-18-18C3,11.075,11.075,3,21,3  M21,0C9.403,0,0,9.403,0,21c0,11.598,9.403,21,21,21c11.598,0,21-9.402,21-21C42,9.403,32.598,0,21,0L21,0z"
})), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#F6921E",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 21,
  y1: 9,
  x2: 21,
  y2: 33
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#F6921E",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 9,
  y1: 21,
  x2: 33,
  y2: 21
}));

var SvgMenuopener = function SvgMenuopener(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    enableBackground: "new 0 0 42 42",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuopener, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Menuopener.6701b000.svg";
export { ForwardRef as ReactComponent };